// Loading screen: the word page's "Esiintyy repliikeissä" index (wordLines.ts buildLineIndex: every
// show line analysed once, 0.5–1 s on a phone), after the dictionary step has installed the form index.
import { defineWarmup } from '../shell/warmup/step';

export const warmup = defineWarmup({
  id: 'show-lines',
  order: 200,
  label: 'lines',
  async run({ appReady }) {
    await appReady;
    const [{ getLexicon }, { buildLineIndex }] = await Promise.all([import('../lib/lexicon'), import('./wordLines')]);
    const { lex, index } = getLexicon();
    if (!lex || index !== 'ready') throw new Error('no form index');
    await buildLineIndex(lex);
  },
});
